/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUrlParameter } from "../functions/get-url-parameter.js";
import { lodashGet } from "../functions/lodash.js";

const __vue_script__ = {
  props: ["value", "allowWeekBillet", "currency", "hideTwoCards"],
  computed: {
    isTrial() {
      return window.plan && window.plan.is_trial;
    },
    isForeign() {
      return window.is_foreign;
    },
    hasCard() {
      return product.payment_methods.includes('credit_card');
    },
    hasCardPix() {
      return product.payment_methods.includes('card_pix');
    },
    hasTwoCards() {
      return !getUrlParameter('hideTwoCard') && !window.is_foreign && product.payment_methods.includes('two_credit_card') && !this.hideTwoCards;
    },
    hasBillet() {
      return !getUrlParameter('hideBillet') && !window.is_foreign && product.payment_methods.includes('billet') && !this.isTrial;
    },
    hasBilletInstallments() {
      return (window.product.billet_installments && window.product.billet_installments > 1 && !this.isTrial);
    },
    hasPix() {
      return !getUrlParameter('hidePix') && !window.is_foreign && product.payment_methods.includes('pix') && !this.isTrial;
    },
    showBillet() {
      if (!this.hasBillet) return false;
      if (!lodashGet(this.allowWeekBillet, "week")) return true;
      return this.allowWeekBillet.week.includes((new Date).getDay());
    }
  }
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isForeign
    ? _c("div", { staticClass: "payment-type-selector d-flex" }, [
        _vm.hasCard && !_vm.hasBilletInstallments
          ? _c(
              "button",
              {
                staticClass: "btn",
                class: { current: _vm.value === "card" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("input", "card")
                  },
                },
              },
              [
                _c("i", { staticClass: "icon-credit-card" }),
                _vm._v("\n    Cartão\n  "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasTwoCards && !_vm.hasBilletInstallments
          ? _c(
              "button",
              {
                staticClass: "btn",
                class: { current: _vm.value === "two-cards" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("input", "two-cards")
                  },
                },
              },
              [
                _c("i", { staticClass: "icon-two-money-cards" }),
                _vm._v("\n    Dois cartões\n  "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasCardPix && !_vm.hasBilletInstallments
          ? _c(
              "button",
              {
                staticClass: "btn",
                class: { current: _vm.value === "card-pix" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("input", "card-pix")
                  },
                },
              },
              [_vm._m(0), _vm._v("\n    Cartão + Pix\n  ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasPix && !_vm.hasBilletInstallments
          ? _c(
              "button",
              {
                staticClass: "btn",
                class: { current: _vm.value === "pix" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("input", "pix")
                  },
                },
              },
              [_c("i", { staticClass: "icon-pix" }), _vm._v("\n    Pix\n  ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showBillet && !_vm.hasBilletInstallments
          ? _c(
              "button",
              {
                staticClass: "btn",
                class: { current: _vm.value === "billet" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("input", "billet")
                  },
                },
              },
              [
                _c("i", { staticClass: "icon-bar-code" }),
                _vm._v("\n    Boleto\n  "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasBilletInstallments
          ? _c(
              "button",
              {
                staticClass: "btn",
                class: { current: _vm.value === "billet-installments" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("input", "billet-installments")
                  },
                },
              },
              [
                _c("i", { staticClass: "icon-bar-code" }),
                _vm._v("\n    Boleto Parcelado\n  "),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex flex-row" }, [
      _c("i", { staticClass: "icon-credit-card" }),
      _vm._v(" "),
      _c("i", { staticClass: "icon-pix" }),
    ])
  },
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-6649ff3b_0", { source: ".payment-type-selector button {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 6px;\n  border: 1px solid rgba(33, 38, 49, 0.4);\n  color: rgba(33, 38, 49, 0.4);\n  padding: 8px;\n  width: 120px;\n  font-size: 12px;\n  line-height: 16px;\n  margin-right: 16px;\n}\n@media screen and (max-width: 767px) {\n.payment-type-selector button {\n    margin-right: 8px;\n}\n}\n.payment-type-selector button:last-child {\n  margin-right: 0;\n}\n.payment-type-selector button i {\n  font-size: 24px;\n  margin-bottom: 2px;\n}\n.payment-type-selector button.current {\n  border-color: #0034f0;\n  color: #0034f0;\n  font-weight: bold;\n}\n\n/*# sourceMappingURL=payment-type-selector.vue.map */", map: {"version":3,"sources":["frontend/components/payment-type-selector.vue","payment-type-selector.vue"],"names":[],"mappings":"AAwGA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uCAAA;EACA,4BAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ACvGA;ADyGA;AAdA;IAeA,iBAAA;ACtGE;AACF;ADwGA;EACA,eAAA;ACtGA;ADyGA;EACA,eAAA;EACA,kBAAA;ACvGA;AD0GA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;ACxGA;;AAEA,oDAAoD","file":"payment-type-selector.vue","sourcesContent":["<template>\n  <div class=\"payment-type-selector d-flex\" v-if=\"!isForeign\">\n    <button\n      v-if=\"hasCard && !hasBilletInstallments\"\n      type=\"button\"\n      class=\"btn\" :class=\"{ current: value === 'card' }\"\n      @click=\"$emit('input', 'card')\"\n    >\n      <i class=\"icon-credit-card\"></i>\n      Cartão\n    </button>\n    <button\n      v-if=\"hasTwoCards && !hasBilletInstallments\"\n      type=\"button\"\n      class=\"btn\" :class=\"{ current: value === 'two-cards' }\"\n      @click=\"$emit('input', 'two-cards')\"\n    >\n      <i class=\"icon-two-money-cards\"></i>\n      Dois cartões\n    </button>\n    <button\n      v-if=\"hasCardPix && !hasBilletInstallments\"\n      type=\"button\"\n      class=\"btn\" :class=\"{ current: value === 'card-pix' }\"\n      @click=\"$emit('input', 'card-pix')\"\n    >\n      <div class=\"d-flex flex-row\">\n        <i class=\"icon-credit-card\"></i>\n        <i class=\"icon-pix\"></i>\n      </div>\n      Cartão + Pix\n    </button>\n    <button\n      v-if=\"hasPix && !hasBilletInstallments\"\n      type=\"button\"\n      class=\"btn\" :class=\"{ current: value === 'pix' }\"\n      @click=\"$emit('input', 'pix')\"\n    >\n      <i class=\"icon-pix\"></i>\n      Pix\n    </button>\n    <button\n      v-if=\"showBillet && !hasBilletInstallments\"\n      type=\"button\"\n      class=\"btn\" :class=\"{ current: value === 'billet' }\"\n      @click=\"$emit('input', 'billet')\"\n    >\n      <i class=\"icon-bar-code\"></i>\n      Boleto\n    </button>\n    <button\n      v-if=\"hasBilletInstallments\"\n      type=\"button\"\n      class=\"btn\" :class=\"{ current: value === 'billet-installments' }\"\n      @click=\"$emit('input', 'billet-installments')\"\n    >\n      <i class=\"icon-bar-code\"></i>\n      Boleto Parcelado\n    </button>\n  </div>\n</template>\n\n<script>\nimport { getUrlParameter } from \"../functions/get-url-parameter.js\";\nimport { lodashGet } from \"../functions/lodash.js\";\n\nexport default {\n  props: [\"value\", \"allowWeekBillet\", \"currency\", \"hideTwoCards\"],\n  computed: {\n    isTrial() {\n      return window.plan && window.plan.is_trial;\n    },\n    isForeign() {\n      return window.is_foreign;\n    },\n    hasCard() {\n      return product.payment_methods.includes('credit_card');\n    },\n    hasCardPix() {\n      return product.payment_methods.includes('card_pix');\n    },\n    hasTwoCards() {\n      return !getUrlParameter('hideTwoCard') && !window.is_foreign && product.payment_methods.includes('two_credit_card') && !this.hideTwoCards;\n    },\n    hasBillet() {\n      return !getUrlParameter('hideBillet') && !window.is_foreign && product.payment_methods.includes('billet') && !this.isTrial;\n    },\n    hasBilletInstallments() {\n      return (window.product.billet_installments && window.product.billet_installments > 1 && !this.isTrial);\n    },\n    hasPix() {\n      return !getUrlParameter('hidePix') && !window.is_foreign && product.payment_methods.includes('pix') && !this.isTrial;\n    },\n    showBillet() {\n      if (!this.hasBillet) return false;\n      if (!lodashGet(this.allowWeekBillet, \"week\")) return true;\n      return this.allowWeekBillet.week.includes((new Date).getDay());\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\">\n.payment-type-selector {\n  button {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 6px;\n    border: 1px solid rgba(33, 38, 49, 0.4);\n    color: rgba(33, 38, 49, 0.4);\n    padding: 8px;\n    width: 120px;\n    font-size: 12px;\n    line-height: 16px;\n    margin-right: 16px;\n    \n    @media screen and (max-width: 767px) {\n      margin-right: 8px;\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    i {\n      font-size: 24px;\n      margin-bottom: 2px;\n    }\n\n    &.current {\n      border-color: #0034f0;\n      color: #0034f0;\n      font-weight: bold;\n    }\n  }\n}\n</style>",".payment-type-selector button {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 6px;\n  border: 1px solid rgba(33, 38, 49, 0.4);\n  color: rgba(33, 38, 49, 0.4);\n  padding: 8px;\n  width: 120px;\n  font-size: 12px;\n  line-height: 16px;\n  margin-right: 16px;\n}\n@media screen and (max-width: 767px) {\n  .payment-type-selector button {\n    margin-right: 8px;\n  }\n}\n.payment-type-selector button:last-child {\n  margin-right: 0;\n}\n.payment-type-selector button i {\n  font-size: 24px;\n  margin-bottom: 2px;\n}\n.payment-type-selector button.current {\n  border-color: #0034f0;\n  color: #0034f0;\n  font-weight: bold;\n}\n\n/*# sourceMappingURL=payment-type-selector.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/payment-type-selector.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__